import { useSortBy } from 'react-instantsearch';

import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';

import { useSearchClient } from '../provider/searchClientProvider';
import useQueryParam from '@lib/hooks/useQueryParam';
import type { HasMotabilityState } from '@javascript/types/InstantSearch';

const defaultSortOptions = [
  { label: 'Relevance', replica: '' },
  { label: 'Monthly payment', replica: '_monthly_asc' },
  { label: 'Monthly payment', replica: '_monthly_dsc' },
  { label: 'Cash price', replica: '_cash_asc' },
  { label: 'Cash price', replica: '_cash_dsc' },
  { label: 'Mileage', replica: '_mileage' },
  { label: 'Age', replica: '_age' },
  { label: 'Recently added', replica: '_recentlyadded' },
  { label: 'Distance', replica: '_geolocation' },
];

const motabilitySortOptions = [
  { label: 'Relevance', replica: '' },
  { label: 'Advanced payment', replica: '_cash_asc' },
  { label: 'Advanced payment', replica: '_cash_dsc' },
];

const checkForSuffix = (sortOrder: string) => {
  if (sortOrder.includes('_asc') || sortOrder.includes('_mileage'))
    return '(low to high)';
  if (sortOrder.includes('_dsc')) return '(high to low)';
  if (sortOrder.includes('_age')) return '(new to old)';
  if (sortOrder.includes('_geo')) return '(near to far)';
  return undefined;
};

const InstantSearchSort = ({ isMotability }: HasMotabilityState) => {
  const { indexName } = useSearchClient();
  const [postcodeParam] = useQueryParam('location');
  const hasLocation = Boolean(postcodeParam);

  const sortOptions = isMotability ? motabilitySortOptions : defaultSortOptions;

  const { currentRefinement, options, refine } = useSortBy({
    items: sortOptions.map(({ label, replica }) => ({
      label,
      value: indexName + replica,
    })),
  });

  const selectedOption = sortOptions.find(
    (option) => option.replica === currentRefinement.replace(indexName, '')
  );

  const selectedSuffix = checkForSuffix(currentRefinement);
  const selectedOptionLabel = `${selectedOption!.label}${
    selectedSuffix ? ` ${selectedSuffix}` : ''
  }`;

  return (
    <InstantSearchAccordion
      additionalStyling="ac-instant-search__sort"
      label={'Sort by'}
      selectedOptions={selectedOptionLabel}
    >
      <ul>
        {options.map(({ value, label }) => {
          const isSelected = currentRefinement === value;
          const suffix = checkForSuffix(value);

          if (value.includes('_geolocation') && !hasLocation) {
            return null;
          }

          return (
            <InstantSearchFilterOption.Radio
              attribute={'sort'}
              isSelected={isSelected}
              key={`${label}-${suffix}`}
              label={label}
              onChange={() => {
                refine(value);
              }}
              suffix={suffix}
            />
          );
        })}
      </ul>
    </InstantSearchAccordion>
  );
};

export default InstantSearchSort;
